import React from 'react'

class PortDashboard extends React.Component {
  state = {}

  componentDidMount() {}

  render() {
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Dashboard</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-12 m-b-10">
                  <h5 className="text-muted">Comming Soon...!</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PortDashboard
